<div class="performance-item">
  @if (hasAvatar()) {
    <img class="performance-item__avatar" [src]="item().avatarUrl" alt="Student" />
  } @else {
    <div class="performance-item__avatar performance-item__avatar--initials">
      {{ getInitials(item().name) }}
    </div>
  }
  <div class="performance-item__info">
    <div class="performance-item__name">{{ item().name }}</div>
    <div class="performance-item__meta">{{ item().coursesLabel }}</div>
  </div>
  <div class="performance-item__badges">
    <div *ngIf="item().warningBadge" class="badge badge--warning">{{ item().warningBadge }}</div>
    <div class="badge badge--success">{{ item().ratingBadge }}</div>
  </div>
  
</div>


